export const setUser = (userId: number | null) => ({
    type: 'SET_USER',
    payload: userId,
  });
  